module.exports = __webpack_public_path__ + "images/company_profile/icon05-d7a226f6945ea8b827eaa2259692d225.png";